var window=global;var $CLJS=require("./cljs_env");require("./cljs_env.js");
'use strict';$CLJS.zC=require("ttag");module.exports=$CLJS.zC;